import { Injectable } from '@angular/core';
import { McticHttpClient, Page, Pageable, McticHttpParams } from '@mctic/ng-core';
import { CartaCreditoTrimestralVO } from '../shared/model/carta-credito-trimestral-vo.model';
import { Observable } from 'rxjs';
import {CartacreditoAnualModel} from '../shared/model/cartacredito-anual.model';
import { Identity } from '../shared/model/identity.model';
import { CartaCreditoFinanceiroGerada } from '../shared/model/carta-credito-financeiro-gerada.model';
import { InvestimentoCreditoFinanceiroVO } from '../shared/model/investimento-credito-financeiro-vo.model';
import { CartaCreditoAnualVO } from '../shared/model/carta-credito-anual-vo.model';
import { EmpresaEnvioCreditoVO } from '../shared/model/empresa-envio-credito-vo.model';
import { TipoSituacaoCartaGeradadaEnum } from '../shared/enum/tipo-situacao-carta-gerada.enum';
import { ValorCartaCreditoFinanceiro } from '../shared/model/valor-carta-credito.model';
import { Pendencia } from '../shared/model/pendencia.model';

@Injectable({
  providedIn: 'root'
})
export class CartaCreditoService {

  private readonly service = '/sepin-backend/rest/carta-credito';
  private readonly serviceValorCartaGerada = '/sepin-backend/rest/valor-credito';

  constructor(private readonly http: McticHttpClient) {

  }

  salvarTrimestral(cartaCredito: CartaCreditoTrimestralVO): Observable<Identity<number>> {
    return this.http.post<Identity<number>>(`${this.service}/trimestral`, cartaCredito);
  }

  salvarAnual(cartaCredito: CartaCreditoTrimestralVO): Observable<Identity<number>> {
    return this.http.post<Identity<number>>(`${this.service}/anual`, cartaCredito);
  }

  salvarAnual2(idCartaCreditoFinanceiro: number, idComposicaoRdaList: number[]): Observable<Identity<number>> {
    return this.http.post<Identity<number>>(`${this.service}/anual/${idCartaCreditoFinanceiro}`, idComposicaoRdaList);
  }

  consultarValorCartasGeradas(pageable: Pageable): Observable<Page<CartaCreditoFinanceiroGerada>> {
    const queryParams = new McticHttpParams().setPageable(pageable).setBoolean('enviado', false);
    return this.http.get<Page<CartaCreditoFinanceiroGerada>>(
      `${this.serviceValorCartaGerada}/query`, { params: queryParams.toHttpParams() }
    );
  }

  consultarValorCartasGeradasRetificando(pageable: Pageable): Observable<Page<ValorCartaCreditoFinanceiro>> {
    const queryParams = new McticHttpParams().setPageable(pageable).setBoolean('enviado', false)
                                            .setNumber('situacaoCarta', TipoSituacaoCartaGeradadaEnum.RETIFICANDO);

    return this.http.get<Page<ValorCartaCreditoFinanceiro>>(
      `${this.serviceValorCartaGerada}/query`, { params: queryParams.toHttpParams() }
    );
  }

  consultarValorCartasGeradasAguardandoOutrasRetificacoes(pageable: Pageable): Observable<Page<ValorCartaCreditoFinanceiro>> {
    const queryParams = new McticHttpParams().setPageable(pageable).setBoolean('enviado', false)
                                            .setNumber('situacaoCarta', TipoSituacaoCartaGeradadaEnum.AGUARDANDO_RETIFICACAO);

    return this.http.get<Page<ValorCartaCreditoFinanceiro>>(
      `${this.serviceValorCartaGerada}/query`, { params: queryParams.toHttpParams() }
    );
  }

  consultarValorCartasEnviadas(pageable: Pageable): Observable<Page<CartaCreditoFinanceiroGerada>> {
    const queryParams = new McticHttpParams().setPageable(pageable).setBoolean('enviado', true);
    return this.http.get<Page<CartaCreditoFinanceiroGerada>>(
      `${this.serviceValorCartaGerada}/query`, { params: queryParams.toHttpParams() }
    );
  }

  obterCartasGeradasTrimestral(): Observable<CartaCreditoTrimestralVO> {
        return this.http.get<CartaCreditoTrimestralVO>(`${this.service}/trimestral`);
  }

  obterCartasGeradasAnual(idComposicaoRdaList: number[]): Observable<CartaCreditoAnualVO> {
      return this.http.post<CartaCreditoAnualVO>(`${this.service}/buscar-anual`, idComposicaoRdaList);
  }

  enviarCartaCredito() {
    return this.http.post(`${this.service}/enviar`, null);
  }

  obterSituacaoEnvioCarta(): Observable<EmpresaEnvioCreditoVO[]> {
    return this.http.get<EmpresaEnvioCreditoVO[]>(`${this.service}/empresas-carta-enviada`);
  }

  obterInvestimentosDeclaradosCreditoFinanceiro(): Observable<InvestimentoCreditoFinanceiroVO> {
    return this.http.get<InvestimentoCreditoFinanceiroVO>(`${this.serviceValorCartaGerada}/investimentos-declarados`);
  }

  removerCartaGeradaPorIdCartaCreditoIdComposicaoRda(idCartaCredito: number, idComposicaoRda: number)
  : Observable<void> {
    return this.http.delete<void>(`${this.service}/${idCartaCredito}/empresa/${idComposicaoRda}`)
  }

  obterEmpresasLivrePendencia(idUnicoPessoaJuridica): Observable<Pendencia[]> {
    return this.http.get<Pendencia[]>(`${this.service}/empresas-livre-pendencia/${idUnicoPessoaJuridica}`);
  }

  obterCartasAnual(idComposicaoRda: number): Observable<CartacreditoAnualModel> {
    return this.http.get<CartacreditoAnualModel>(`${this.service}/anual/${idComposicaoRda}`);
  }

  obterRetificacaoCartasAnual(idComposicaoRda: number): Observable<CartacreditoAnualModel> {
    return this.http.get<CartacreditoAnualModel>(`${this.service}/retificacao/anual/${idComposicaoRda}`);
  }

  periodoAnualDisponivel(): Observable<boolean> {
    return this.http.get<boolean>(`${this.service}/periodo-anual-disponivel`);
  }
}
